import {limit} from "../filters/limit";

require('./bootstrap');
import Vue from 'vue'

window.Vue = Vue;

import Notifications from 'vue-notification';
Vue.use(Notifications)

import 'aos/dist/aos.css'

Vue.config.productionTip = false

import Vuex from "vuex";
Vue.use(Vuex)

import store from "./store/store";

import VueRouter from 'vue-router';
import router from "./routes";

import Bugsnag from "../plugins/Bugsnag.js";
Bugsnag(store);
import vuetify from "@/plugins/vuetify"
import { isInDevelop, isNotInDevelop } from "@/constants/general";

Vue.mixin({
  data() {
    return {
      isInDevelop,
      isNotInDevelop,
    }
  }
})

Vue.use(VueRouter)
new Vue({
    el: '#app',
    vuetify,
    filters: {
        limit,
    },
    store,
    router,
});

